import { useTireSideFiltersEnabled } from '../components/TireSearchNew/ProductListTireSearch';
import useIsBicycleCategory from './useIsBicycleCategory';

const useDefaultSorting = () => {
    const defaultSorting = ['retailPrice', 'desc'];
    const { isBicycleCategory, loading } = useIsBicycleCategory();
    const { enabled: tireSearchEnabled, loading: categoryLoading } =
        useTireSideFiltersEnabled();

    const sort = [defaultSorting];

    if (isBicycleCategory) {
        sort.unshift(['custom', 'asc']);
    }
    if (tireSearchEnabled) {
        sort.unshift(['tireCompatibility', 'asc']);
    }

    return {
        defaultSorting: sort[0],
        loading: loading || categoryLoading,
    };
};

export default useDefaultSorting;
